// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Set Fund Password — scoped .sfp-* */

.sfp-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 48px;
  max-width: 1200px;
  margin: 0 auto;
}

.sfp-page *,
.sfp-page *::before,
.sfp-page *::after {
  box-sizing: border-box;
}

.sfp-page__crumbs {
  margin-bottom: 18px;
}

.sfp-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.sfp-page__crumbItem--active {
  color: #e0e0e0;
}

body.light_theme .sfp-page__crumbItem--active {
  color: #101828;
}

.sfp-page__crumbSep {
  color: #8e939c;
}

.sfp-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.set_fundform_outer {
  max-width: 600px;
  margin: 60px auto;
}

.sfp-page__title {
  margin: 0 0 28px;
  font-size: 36px;
  font-weight: 600;
  color: #f0f0f0;
  text-align: left;
}

body.light_theme .sfp-page__title {
  color: #101828;
}

.sfp-field {
  margin-bottom: 20px;
}

.sfp-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #d0d0d0;
  margin-bottom: 6px;
  text-align: left;
}

body.light_theme .sfp-label {
  color: #101828;
}

.sfp-inputWrap {
  position: relative;
}

.sfp-input {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  padding: 0 44px 0 14px;
  font-size: 13px;
  font-weight: 600;
  color: #f0f0f0;
  outline: none;
}

body.light_theme .sfp-input {
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  color: #101828;
}

.sfp-input--code {
  padding-right: 64px;
}

.sfp-input::placeholder {
  color: rgba(200, 200, 200, 0.55);
  -webkit-text-fill-color: rgba(200, 200, 200, 0.55);
  opacity: 1;
}

body.light_theme .sfp-input::placeholder {
  color: #9ca3af;
  -webkit-text-fill-color: #9ca3af;
}

.sfp-input:focus {
  border-color: rgba(255, 255, 255, 0.3);
  outline: none;
}

body.light_theme .sfp-input:focus {
  border-color: #d1aa67;
}

.sfp-togglePw {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

body.light_theme .sfp-togglePw {
  color: #6b7280;
}

.sfp-togglePw:hover {
  color: #e0e0e0;
}

body.light_theme .sfp-togglePw:hover {
  color: #111827;
}

.sfp-hint {
  margin-top: 8px;
  font-size: 14px;
  color: #94a3b8;
  font-weight: 400;
  text-align: left;
}

body.light_theme .sfp-hint {
  color: #4A5565;
}

.sfp-hint--warn {
  color: #f87171;
}

body.light_theme .sfp-hint--warn {
  color: #b42318;
}

.sfp-hint--single {
  margin-top: 0;
}

/* method picker removed: we auto-select highest priority */

.sfp-send {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  color: #ac8a50;
  cursor: pointer;
}

.sfp-confirm {
  display: block;
  width: 100%;
  height: 48px;
  margin-top: 12px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
}

.sfp-confirm.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}

.sfp-unable {
  display: block;
  width: 100%;
  margin-top: 18px;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

body.light_theme .sfp-unable {
  color: #070808;
}

@media (max-width: 991px) {
  .sfp-page__title {
    font-size: 24px;
  }

}

@media (max-width: 767px) {

  .sfp-page__title {
    font-size: 22px;
  }

  .set_fundform_outer {
    margin: 30px auto;
  }

  .sfp-label {
    font-size: 13px;
  }

  .sfp-confirm {
    height: 42px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/setFundPassword.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,2DAA2D;;AAE3D;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Set Fund Password — scoped .sfp-* */\n\n.sfp-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 48px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.sfp-page *,\n.sfp-page *::before,\n.sfp-page *::after {\n  box-sizing: border-box;\n}\n\n.sfp-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.sfp-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.sfp-page__crumbItem--active {\n  color: #e0e0e0;\n}\n\nbody.light_theme .sfp-page__crumbItem--active {\n  color: #101828;\n}\n\n.sfp-page__crumbSep {\n  color: #8e939c;\n}\n\n.sfp-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.set_fundform_outer {\n  max-width: 600px;\n  margin: 60px auto;\n}\n\n.sfp-page__title {\n  margin: 0 0 28px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #f0f0f0;\n  text-align: left;\n}\n\nbody.light_theme .sfp-page__title {\n  color: #101828;\n}\n\n.sfp-field {\n  margin-bottom: 20px;\n}\n\n.sfp-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #d0d0d0;\n  margin-bottom: 6px;\n  text-align: left;\n}\n\nbody.light_theme .sfp-label {\n  color: #101828;\n}\n\n.sfp-inputWrap {\n  position: relative;\n}\n\n.sfp-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  padding: 0 44px 0 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #f0f0f0;\n  outline: none;\n}\n\nbody.light_theme .sfp-input {\n  border: 1px solid #e5e7eb;\n  background: #f3f4f6;\n  color: #101828;\n}\n\n.sfp-input--code {\n  padding-right: 64px;\n}\n\n.sfp-input::placeholder {\n  color: rgba(200, 200, 200, 0.55);\n  -webkit-text-fill-color: rgba(200, 200, 200, 0.55);\n  opacity: 1;\n}\n\nbody.light_theme .sfp-input::placeholder {\n  color: #9ca3af;\n  -webkit-text-fill-color: #9ca3af;\n}\n\n.sfp-input:focus {\n  border-color: rgba(255, 255, 255, 0.3);\n  outline: none;\n}\n\nbody.light_theme .sfp-input:focus {\n  border-color: #d1aa67;\n}\n\n.sfp-togglePw {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\nbody.light_theme .sfp-togglePw {\n  color: #6b7280;\n}\n\n.sfp-togglePw:hover {\n  color: #e0e0e0;\n}\n\nbody.light_theme .sfp-togglePw:hover {\n  color: #111827;\n}\n\n.sfp-hint {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #94a3b8;\n  font-weight: 400;\n  text-align: left;\n}\n\nbody.light_theme .sfp-hint {\n  color: #4A5565;\n}\n\n.sfp-hint--warn {\n  color: #f87171;\n}\n\nbody.light_theme .sfp-hint--warn {\n  color: #b42318;\n}\n\n.sfp-hint--single {\n  margin-top: 0;\n}\n\n/* method picker removed: we auto-select highest priority */\n\n.sfp-send {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 700;\n  color: #ac8a50;\n  cursor: pointer;\n}\n\n.sfp-confirm {\n  display: block;\n  width: 100%;\n  height: 48px;\n  margin-top: 12px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: not-allowed;\n}\n\n.sfp-confirm.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n.sfp-unable {\n  display: block;\n  width: 100%;\n  margin-top: 18px;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #94a3b8;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\nbody.light_theme .sfp-unable {\n  color: #070808;\n}\n\n@media (max-width: 991px) {\n  .sfp-page__title {\n    font-size: 24px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .sfp-page__title {\n    font-size: 22px;\n  }\n\n  .set_fundform_outer {\n    margin: 30px auto;\n  }\n\n  .sfp-label {\n    font-size: 13px;\n  }\n\n  .sfp-confirm {\n    height: 42px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
